export default class FooterAccordion {
    static init(): void {
        const accordionElements = document.querySelectorAll('.js-base-footer-accordion');

        accordionElements.forEach((accordion: Element) => {
            // Funkce pro kontrolu šířky okna
            const isMobile = (): boolean => window.innerWidth <= 767;

            // Funkce pro reset accordion na desktop
            const resetAccordion = (list: HTMLElement): void => {
                list.style.height = '';
                list.style.overflow = '';
                list.style.transition = '';
                accordion.classList.remove('accordion-open', 'accordion-closed');
                trigger.classList.remove('is-open');
            };
            const trigger = accordion.querySelector('.base-footer-item__trigger') as HTMLElement;
            const list = accordion.querySelector('.base-footer-item__list') as HTMLElement;

            if (!trigger || !list) return;

            // Funkce pro inicializaci accordion funkcionality
            const initMobileAccordion = (): void => {
                if (!isMobile()) return;

                // Nastavíme počáteční stav - zavřeno
                list.style.height = '0px';
                list.style.overflow = 'hidden';
                list.style.transition = 'height 0.3s ease-in-out';

                // Přidáme class pro identifikaci stavu
                accordion.classList.add('accordion-closed');
            };

            // Event listener pro klik na trigger
            trigger.addEventListener('click', () => {
                // Funkce funguje pouze na mobile
                if (!isMobile()) return;

                const isOpen = accordion.classList.contains('accordion-open');

                if (isOpen) {
                    // Zavřít accordion
                    list.style.height = '0px';
                    accordion.classList.remove('accordion-open');
                    accordion.classList.add('accordion-closed');
                    trigger.classList.remove('is-open');
                } else {
                    // Otevřít accordion - získáme přirozenou výšku
                    list.style.height = 'auto';
                    const naturalHeight = list.offsetHeight + 'px';
                    list.style.height = '0px';

                    // Trigger reflow a pak animujeme
                    list.offsetHeight; // Force reflow
                    list.style.height = naturalHeight;

                    accordion.classList.remove('accordion-closed');
                    accordion.classList.add('accordion-open');
                    trigger.classList.add('is-open');
                }
            });

            // Event listener pro změnu velikosti okna
            window.addEventListener('resize', () => {
                if (isMobile()) {
                    initMobileAccordion();
                } else {
                    resetAccordion(list);
                }
            });

            // Inicializace při načtení
            initMobileAccordion();
        });
    }
}
